import React, {PropsWithChildren} from 'react';
import styles from './management-panel.module.css';

export function ManagementPanel(props: PropsWithChildren) {
    return <div className={styles.container}>{props.children}</div>;
}
